var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'e-counseling-event-status',
    ("e-counseling-event-status--" + _vm.status)
  ],attrs:{"label":_vm.text}},[_c('span',{class:[_vm.icon, 'e-counseling-event-status__icon', 'mr-1']}),_c('span',{staticClass:"e-counseling-event-status__text",domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }